import * as rmd from 'material-ui';
import React, { Component } from 'react';

class OddsPicker extends Component {
    static defaultProps = {};

    constructor(props, context) {
        super(props, context);

        this.state = {
            oldValue: props[`${props.propKey}Old`] || '',
            newValue: props[`${props.propKey}New`] || ''
        };
    }

    render() {
        return (
            <div>
                <div style={{ marginTop: '15px' }}>{this.props.label}</div>

                <rmd.TextField
                    value={this.state.oldValue}
                    onChange={(e, value) => {
                        this.setState({ oldValue: value }, () => {
                            this.props.onChange(`${this.props.propKey}Old`, value);
                        });
                    }}
                    errorText={this.props.error}
                    floatingLabelText={'Old' || `${this.props.propKey}`}
                    fullWidth={false}
                    style={{ margin: '0 5px', width: 'calc(50% - 10px)' }}
                />

                <rmd.TextField
                    value={this.state.newValue}
                    onChange={(e, value) => {
                        this.setState({ newValue: value }, () => {
                            this.props.onChange(`${this.props.propKey}New`, value);
                        });
                    }}
                    errorText={this.props.error}
                    floatingLabelText={'New' || `${this.props.propKey}`}
                    fullWidth={false}
                    style={{ margin: '0 5px', width: 'calc(50% - 10px)' }}
                />
            </div>
        );
    }
}

export default OddsPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/OddsPicker.js
 **/